import { c as _c } from "react/compiler-runtime";
import React from 'react';
interface MenuItem {
  label: string;
  isActive?: boolean;
  onClick: () => void;
}
interface TabMenusProps {
  items: MenuItem[];
  activeColor?: string;
  inactiveColor?: string;
}
const TabMenus: React.FC<TabMenusProps> = t0 => {
  const $ = _c(17);
  const {
    items,
    activeColor: t1,
    inactiveColor: t2
  } = t0;
  const activeColor = t1 === undefined ? "#012061" : t1;
  const inactiveColor = t2 === undefined ? "#555555" : t2;
  const columnCount = Math.ceil(items.length / 10);
  const t3 = `${columnCount * 180}px`;
  let t4;
  if ($[0] !== t3) {
    t4 = {
      width: "auto",
      minWidth: t3
    };
    $[0] = t3;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== inactiveColor) {
    t5 = {
      gridTemplateRows: "repeat(10, auto)",
      gridAutoFlow: "column",
      color: inactiveColor
    };
    $[2] = inactiveColor;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== activeColor || $[5] !== inactiveColor || $[6] !== items) {
    let t7;
    if ($[8] !== activeColor || $[9] !== inactiveColor) {
      t7 = (item, index) => <li key={index} onClick={item.onClick} className={`cursor-pointer hover:bg-gray-100 px-2 py-1.5 rounded text-sm whitespace-nowrap ${item.isActive ? "font-medium bg-[#E5E8EF]" : ""}`} style={{
        color: item.isActive ? activeColor : inactiveColor
      }}>{item.label}</li>;
      $[8] = activeColor;
      $[9] = inactiveColor;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    t6 = items.map(t7);
    $[4] = activeColor;
    $[5] = inactiveColor;
    $[6] = items;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <ul className="grid gap-x-4 gap-y-1 text-14-tamil-400 leading-relaxed" style={t5}>{t6}</ul>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className="bg-white border border-[#E0E0E0] p-3 shadow-lg rounded-md max-w-[calc(100vw-20px)]" style={t4}>{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
};
export default TabMenus;